module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kb-Ld.dcceae80.png";